export default __webpack_public_path__ + "static/media/Boys_Skipping_Rope.028c2420.svg";